interface Description {
  title: string;
  title_2: string;
  title_3: string;
  content: string[];
}

interface Story {
  title: string;
  content: string[];
}

interface Schedule {
  content: string[];
}

interface Ticket {
  content: string[];
  SameDayTicket: string[];
  AdditionalSales: string[];
}

interface TicketSales {
  content: string[];
  SecondRound: string[];
  Lowticket: string[];
  pia: string[];
  ePlus: string[];
  CnPlayGuide: string[];
}

interface Performer {
  content: string[];
}

interface Cautions {
  content: string[];
}

interface Credits {
  content: string[];
}

interface Texts {
  TOPGUN_TITLE: string;
  TOPGUN_TITLE_2: string;
  TOPGUN_TITLE_3: string;
  CONTENT: string;
  MAIN_CONTENT_2: string;
  MAIN_CONTENT_3: string;
  MAIN_CONTENT_4: string;
  MAIN_CONTENT_5: string;
  MAIN_CONTENT_6: string;
  MAIN_CONTENT_7: string;
  MAIN_CONTENT_8: string;
  MAIN_CONTENT_9: string;
  MAIN_CONTENT_10: string;
  MAIN_CONTENT_11: string;
  MAIN_CONTENT_12: string;
  Description: Description;
  Story: Story;
  Schedule: Schedule;
  Ticket: Ticket;
  TicketSales: TicketSales;
  Performer: Performer;
  Cautions: Cautions;
  Credits: Credits;
}

export const TEXTS: Texts = {
  TOPGUN_TITLE: "歴史的大ヒット『トップガン マーヴェリック』",
  TOPGUN_TITLE_2: "東京では即日SOLD OUTとなった超話題作！",
  TOPGUN_TITLE_3: "全世代待望のシネマコンサートがついに大阪上陸！",
  CONTENT:
    "日本では2022年5月に公開され、興行収入が驚異の137億円を突破した\n映画『トップガン マーヴェリック』",
  MAIN_CONTENT_2: "2022年の国内映画興行収入ランキングで洋画部門第1位を獲得し、",
  MAIN_CONTENT_3:
    "全世界ではトム・クルーズの\u200Bキャリア最高額と\u200Bなる10億ドル超えの\u200B大ヒットを記録！",
  MAIN_CONTENT_4: "まさに映画史に名を刻む伝説の作品となった。",
  MAIN_CONTENT_5:
    "そんな大ヒット作品をオーケストラの極上の生演奏とともに上映し、",
  MAIN_CONTENT_6:
    "イギリスやドイツをはじめ全世界10都市以上で大好評を博し、\n今年８月には東京も熱狂の渦に巻き込んだ",
  MAIN_CONTENT_7:
    "「トップガン マーヴェリック シネマコンサート」が\n遂に大阪で開催決定！",
  MAIN_CONTENT_8: "日本中に熱狂を巻き起こした『トップガン マーヴェリック』を",
  MAIN_CONTENT_9:
    "＜大スクリーンでの映画全編上映 × オーケストラによる大迫力の生演奏＞でお届けする、",
  MAIN_CONTENT_10: "全世代が楽しめる最高のエンターテインメント・コンサート！",
  MAIN_CONTENT_11:
    "大阪城ホールの「トップガン マーヴェリック シネマコンサート」で",
  MAIN_CONTENT_12:
    "熱い感動と興奮に満ちた忘れられないひとときをお楽しみください！",
  Description: {
    title: "「シネオケ",
    title_2: "®",
    title_3: "とは？」",
    content: [
      "“大スクリーンでの映画上映 × オーケストラ生演奏による音楽”でお届けする\n新たなスタイルのコンサート「シネオケ®」。",
      "演奏を聴くだけではなく、映画そのものを大スクリーンで楽しめるので、\n大迫力の「映像」とオーケストラの極上の演奏による「音楽」の両方を卓越した臨場感で体験でき、\n作品の世界観に没入できます。",
      "「シネオケ®」は、株式会社キョードー東京の商標です。",
    ],
  },
  Story: {
    title: "上映作品",
    content: [
      "トップガン マーヴェリック",
      "(2022年公開作品）",
      "英語上映・日本語字幕 / 上映時間：約2時間15分（休憩除く）",
      "監督 : ジョセフ・コジンスキー",
      "音楽 : ローン・バルフ、ハロルド・フォルターメイヤー、\nレディー・ガガ、ハンス・ジマー",
      "アメリカ海軍のエリートパイロット養成学校トップガンに、",
      "伝説のパイロット、マーヴェリックが教官として帰ってきた。\n空の厳しさと美しさを誰よりも知る彼は、",
      "守ることの難しさと戦うことの厳しさを教えるが、訓練生たちはそんな彼の型破りな指導に戸惑い反発する。",
      "その中には、かつてマーヴェリックとの訓練飛行中に命を落とした相棒グースの息子ルースターの姿もあった。",
      "ルースターはマーヴェリックを恨み、彼と対峙するが……。",
      "ABOUT THE MOVIE",
      "※途中20分のインターミッション有、公演全体は2時間35分予定",
    ],
  },
  Schedule: {
    content: [
      "2025年",
      "11",
      "月",
      "2",
      "日",
      "（日）",
      "昼公演・開場15:00 開演16:00",
      "夜公演・開場17:30 開演18:30",
      "※英語上映・日本語字幕",
      "会場",
      "大阪城ホール",
      "〒540-0002 大阪市中央区大阪城3番1号",
      "（外部リンク）",
    ],
  },
  Ticket: {
    content: [
      "料金",
      "S席 9,900 円",
      "A席 8,800 円",
      "B席 4,900 円",
      "全席指定席・税込",
      "CN プレイガイド",
      "ご購入はこちらから",
      "全席指定席・税込",
      "お問い合わせ",
      "キョードーインフォメーション 0570-200-888",
      "（平日12時～17時 / ※土日祝休業）",
    ],
    AdditionalSales: [
      "追加販売",
      "注釈付き 見切れS席",
      "（追加販売・先着）",
      "2025年8月1日(金) 正午12:00～",
      "お申込み",
      "※ステージ全体や出演者、映像および演出の一部が見えづらい場合がございます。",
      "注釈付き 見切れS席 9,900 円",
      "※スピーカーが近いため、音量が大きいと感じる場合がございます。",
    ],

    SameDayTicket: [
      "当日券について",
      "S席 10,400 円",
      "A席 9,300 円",
      "当日券は、開場時刻の15:00より、\n大阪城ホール北口当日券販売所で販売いたします。",
      "お支払方法は現金のみとなりますので、予めご了承ください。",
      "※当日券は数に限りがございます。",
      "予定枚数に達し次第、販売終了となりますので、\nお早めにお求めください。",
    ],
  },
  TicketSales: {
    content: [
      "先行販売",
      "オフィシャル先行",
      "受付期間：2025年9月19日(金) 18:00 〜 2025年9月28日(日) 23:59",
      "お申込み",
      "一般販売",
      "一般販売",
      "10/11(土)10:00 〜",
      "COMING SOON",
      "（抽選）",
      "（先着）",
      "受付終了",
    ],
    SecondRound: [
      "オフィシャル2次先行",
      "受付期間：2025年9月29日(月) 12:00 〜 2025年10月8日(水) 23:59",
    ],
    Lowticket: ["ローチケ", "Lコード：51540"],
    pia: ["チケットぴあ", "Pコード：311-212"],
    ePlus: ["イープラス", "Eコード：311-213"],
    CnPlayGuide: [
      "CNプレイガイド一般発売",
      "電話番号：0570-08-9999(オペレーター対応 10:00～18:00)",
      "ファミリーマート店内マルチコピー機から",
    ],
  },
  Performer: {
    content: [
      "指揮",
      "吳曜宇",
      "ウー・ヤオユー",
      `台湾人指揮者、吳曜宇（ウー・ヤオユー） は、権威あるブザンソン国際若手指揮者コンクールにてグランプリ、オーケストラ賞、聴衆賞を24歳の時に受賞し、史上最年少で三冠を達成した。2023年には、香港国際指揮者コンクールで第2位を獲得し、課題作品の最優秀演奏賞と聴衆賞も受賞するなど、国際的な評価をさらに高めている。`,
      `吳は、表現の明快さと洗練された優雅さを融合させた指揮スタイルで広く称賛されており、オーケストラと聴衆の両方を魅了している。現在は高雄交響楽団の常任指揮者を務めており、2021～22および2022～23シーズンには台湾フィルハーモニー管弦楽団（国家交響楽団）の副指揮者を務めた。また、以前は台北フィルハーモニー青少年管弦楽団の音楽監督兼首席指揮者を務めていた。`,
      `彼の活動はヨーロッパとアジアに広がり、これまでに以下のオーケストラを指揮している：サンクトペテルブルク交響楽団、ポーランド国立放送交響楽団、ボルドー・アキテーヌ国立管弦楽団、ロレーヌ国立管弦楽団、ロワール地方国立管弦楽団、香港シンフォニエッタ、マカオ管弦楽団、台湾フィルハーモニー管弦楽団、国立台湾交響楽団、台北交響楽団、エバーグリーン交響楽団。`,
      "演奏",
      "WOWOW シネマオーケストラwith 神戸市室内管弦楽団",
      "",
      "Photo: Tat Keng Tey",
    ],
  },
  Cautions: {
    content: [
      "注意事項",
      "※キャストの登壇はございません。",
      "※英語上映・日本語字幕となります。",
      "※お一人様1 公演につき4 枚までご購入いただけます。",
      "※5 歳未満のお子様はご入場できません。",
      "※車いすをご利用のお客様はS席をご購入いただき、",
      "　事前にキョードーインフォメーション 0570-200-888（平日12：00 ～ 17：00 ※土日祝休業）まで来場の旨をご連絡ください。",
      "※万が一出演者が変更になった場合でも、チケットの払い戻しには対応いたしかねます。",
    ],
  },
  Credits: {
    content: [
      "“A Royal Albert Hall production” and “With thanks to esk film and Avex Classics International”　\nSymphonic Cinema Presents",
      "“Original Music Score by　\nLorne Balfe, Harold Faltermeyer, Lady Gaga and Hans Zimmer.”",
      "主催 :",
      "関西テレビ放送",
      "企画・制作",
      "企画協力 :",
      "松竹音楽出版",
      "運営協力 :",
      "キョードー関西",
    ],
  },
};
